/**
 * @generated SignedSource<<8085bdb4ab57fafceda3c3e9182938f0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type AuctionLotStatus = "CANCELED" | "CLOSED" | "DELETED" | "DRAFT" | "OPEN" | "PAUSED" | "SCHEDULED" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type ItemTileBase_item$data = {
  readonly classification: {
    readonly creationDate: string | null;
  } | null;
  readonly creators: ReadonlyArray<{
    readonly attribution: string | null;
    readonly creator: {
      readonly displayName: string | null;
    } | null;
  } | null> | null;
  readonly displayPrice: ReadonlyArray<{
    readonly textType: string | null;
  } | null> | null;
  readonly isArt: boolean | null;
  readonly isAuctionEnabled: boolean | null;
  readonly linkData: {
    readonly " $fragmentSpreads": FragmentRefs<"SeoLink_linkData">;
  };
  readonly localizedPdpUrl: string | null;
  readonly pdpMeta: {
    readonly topQuery: string | null;
  } | null;
  readonly relevantAuctionLot: {
    readonly status: AuctionLotStatus | null;
  } | null;
  readonly relevantAuctionSolution: {
    readonly hasReserve: boolean | null;
  } | null;
  readonly seller?: {
    readonly sellerProfile: {
      readonly company: string | null;
    } | null;
    readonly serviceId: string | null;
  } | null;
  readonly serviceId: string | null;
  readonly title: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"AuctionBids_item" | "Price_item" | "ProductTileMeasurements_item" | "QuickViewItem_item" | "Shipping_item" | "StorefrontOnly_item" | "SwatchSelectorMinimal_item">;
  readonly " $fragmentType": "ItemTileBase_item";
};
export type ItemTileBase_item$key = {
  readonly " $data"?: ItemTileBase_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"ItemTileBase_item">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v1 = {
  "kind": "Variable",
  "name": "page",
  "variableName": "pageDisplayEnum"
},
v2 = [
  (v1/*: any*/)
],
v3 = {
  "kind": "Variable",
  "name": "isTrade",
  "variableName": "isTrade"
},
v4 = {
  "kind": "Variable",
  "name": "priceBookName",
  "variableName": "priceBookName"
},
v5 = {
  "kind": "Variable",
  "name": "userCountryCode",
  "variableName": "userCountryCode"
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": "",
      "kind": "LocalArgument",
      "name": "buyerId"
    },
    {
      "defaultValue": true,
      "kind": "LocalArgument",
      "name": "fetchLiveShipmentQuote"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "fetchShippingCostInfo"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "isTrade"
    },
    {
      "defaultValue": "searchAndBrowse",
      "kind": "LocalArgument",
      "name": "pageDisplayEnum"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "priceBookName"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "showSeller"
    },
    {
      "defaultValue": true,
      "kind": "LocalArgument",
      "name": "showShippingBadge"
    },
    {
      "defaultValue": "",
      "kind": "LocalArgument",
      "name": "userCountryCode"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "ItemTileBase_item",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "pdpMetaItems",
      "kind": "LinkedField",
      "name": "pdpMeta",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "topQuery",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "localizedPdpUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemClassification",
      "kind": "LinkedField",
      "name": "classification",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "creationDate",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemCreator",
      "kind": "LinkedField",
      "name": "creators",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "attribution",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Creator",
          "kind": "LinkedField",
          "name": "creator",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "displayName",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isArt",
      "storageKey": null
    },
    {
      "condition": "showSeller",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Seller",
          "kind": "LinkedField",
          "name": "seller",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "SellerProfile",
              "kind": "LinkedField",
              "name": "sellerProfile",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "company",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "LinkData",
      "kind": "LinkedField",
      "name": "linkData",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SeoLink_linkData"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": (v2/*: any*/),
      "concreteType": "AuctionSolution",
      "kind": "LinkedField",
      "name": "relevantAuctionSolution",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasReserve",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": (v2/*: any*/),
      "concreteType": "AuctionLot",
      "kind": "LinkedField",
      "name": "relevantAuctionLot",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        (v3/*: any*/),
        (v1/*: any*/),
        (v4/*: any*/),
        (v5/*: any*/)
      ],
      "concreteType": "ItemDisplayPriceType",
      "kind": "LinkedField",
      "name": "displayPrice",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "textType",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isAuctionEnabled",
      "storageKey": null
    },
    {
      "condition": "showShippingBadge",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": [
            {
              "kind": "Variable",
              "name": "buyerId",
              "variableName": "buyerId"
            },
            {
              "kind": "Variable",
              "name": "fetchLiveShipmentQuote",
              "variableName": "fetchLiveShipmentQuote"
            },
            {
              "kind": "Variable",
              "name": "fetchShippingCostInfo",
              "variableName": "fetchShippingCostInfo"
            }
          ],
          "kind": "FragmentSpread",
          "name": "Shipping_item"
        }
      ]
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "StorefrontOnly_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SwatchSelectorMinimal_item"
    },
    {
      "args": [
        (v3/*: any*/),
        {
          "kind": "Variable",
          "name": "pageDisplayEnum",
          "variableName": "pageDisplayEnum"
        },
        (v4/*: any*/),
        (v5/*: any*/)
      ],
      "kind": "FragmentSpread",
      "name": "Price_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "QuickViewItem_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProductTileMeasurements_item"
    },
    {
      "args": (v2/*: any*/),
      "kind": "FragmentSpread",
      "name": "AuctionBids_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};
})();

(node as any).hash = "afbfdd9da22946c20b05500b1f7aeaa1";

export default node;
